
import { Button } from "@/components/ui/button";
import { NewSearchFilter } from "./new-search-filter";

type Props = {
  onSearch?: () => void;
}

const Filter = ({
  onSearch
}:Props) => {
  return (
    <div className="p-2 bg-foreground/10 rounded-full flex justify-between items-center">
      <NewSearchFilter 
        onSearch={onSearch}
      />
      <Button variant="link" shape="pill" size="2xl" disabled>
        Mijn opgeslagen filters (0)
      </Button>
    </div>
  );
};

export default Filter;
